import { TableConfig } from '@shared/interfaces/table/table-config';
import { addressPartial } from '@shared/columns/meteringpoint.columns';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { DATE_TIME_FORMAT } from '@app/core/constants/date-time-format';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { DashboardQueryFailedAutomationsResultDto } from '@app/api/dmc';
import { dashboardMeteringPointIdentificationPartial } from '@shared/columns/dashboard.columns';

export const failedAutomationsTable: TableConfig<DashboardQueryFailedAutomationsResultDto> = {
  exportable: true,
  pageSize: 25,
  selectable: true,
  selectableType: 'multiple',
  columns: [
    dashboardMeteringPointIdentificationPartial,
    addressPartial,
    meteringPointTypePartial,
    {
      title: 'chargeInformation.table.type',
      key: 'chargeInformationType',
    },
    {
      title: 'chargeInformation.table.automationstarted',
      key: 'automationStarted',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT
      }
    },
    {
      title: 'chargeInformation.table.rsmstatus',
      key: 'status',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        notset: 'enum.rsmStatus.notSet',
        failed: 'enum.rsmStatus.failed',
        completed: 'enum.rsmStatus.completed',
        waiting: 'enum.rsmStatus.waiting',
        aborted: 'enum.rsmStatus.aborted',
        awaitingnetworkplacement: 'enum.rsmStatus.awaitingNetworkPlacement',
        manuallyhandled: 'enum.rsmStatus.manuallyHandled',
      }
    }
  ]
}
